$('.book-collapse').on('click', function (book) {
    var bookTarget = $(book.target).parent();

    var toogleElementId = bookTarget.attr('data-target');
    var toogleElement = $(toogleElementId);
    var bookInfo = $(bookTarget.parent()).find('.book_info_hidden');
    bookToView = bookInfo.find('.hidden-book-id').val();
    bookInView = toogleElement.find('.hidden-book-id').val();

    if(bookInView !== bookToView)
        toogleElement.removeClass('show');

    toogleElement.find('.card-body').html(bookInfo.html());
});

$(document).ready(function(){
    $("[rel=tooltip]").tooltip({ placement: 'right'});
});


//Prevent double click on form.submit()
$(document).ready(function () {
    $("form").on('submit', function () {
        $(this).find(':submit').attr( 'disabled','disabled' );
        //the rest of your code
        setTimeout(() => {
            $(this).find(':submit').attr( 'disabled',false );
        }, 10000)
    });
});
